import request from '@/utils/request'

/** 支付方式下拉（未删且启用；value 为中文名称，兼容 fkfs） */
export function getPaymentMethodSelector() {
  return request({
    url: '/api/Extend/LqPaymentMethod/Selector',
    method: 'get'
  })
}

/** 转为 { value, label } 选项（value 为中文名称，兼容历史 fkfs） */
export function mapPaymentMethodOptions(res) {
  const list = (res && res.data && res.data.list) || []
  return list.map(item => {
    const name = item.fullName || item.methodName || item.name || ''
    return { value: name, label: name }
  }).filter(item => item.value)
}

/** 转为字符串数组（列表筛选用） */
export function mapPaymentMethodLabels(res) {
  return mapPaymentMethodOptions(res).map(item => item.value)
}

/** 默认支付方式：优先微信，否则第一项或空 */
export function resolveDefaultPaymentMethod(options) {
  if (!options || !options.length) return ''
  if (options.some(item => item.value === '微信')) return '微信'
  return options[0].value
}
